import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class AppPermissionService {
    private requestAppPermissions: Subject<any> = new Subject<any>();
    private requestAppPermissionsStatus: Subject<boolean> = new Subject<boolean>();
    private requestAppMicrophonePermissions: Subject<any> = new Subject<any>();
    private requestAppMicrophonePermissionStatus: Subject<boolean> = new Subject<boolean>();
    fileDownloadBlob$ = new Subject<{
        blob: Blob;
        fileName: string;
        mimeType: string;
    }>();
    constructor() {}

    requestAppCameraPermissions() {
        return this.requestAppPermissions
    }

    receiveAppCameraPermissionStatus() {
        return this.requestAppPermissionsStatus
    }

    requestAppMicrophonePermission() {
        return this.requestAppMicrophonePermissions

    }
    
    receiveAppMicrophonePermissionStatus() {
        return this.requestAppMicrophonePermissionStatus
    }

    downloadFileInApp(blob: { blob: Blob; fileName: string; mimeType: string; }) {
        this.fileDownloadBlob$.next(blob);
    }
}